import { Component } from "@builder.io/sdk";

export const benefitsCiVrConfig: Component = {
  name: "Benefits CI-VR",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "benefits",
      friendlyName: "Section ID",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "title",
      type: "string",
      defaultValue: "Benefits",
      friendlyName: "Section Title",
      helperText:
        "The main heading that appears at the top of the benefits section",
      required: true,
    },
    {
      name: "benefits",
      type: "list",
      friendlyName: "Benefits List",
      defaultValue: [
        {
          title: "Simulates Real Client Interactions",
          text: "Experience real interactions with virtual clients to see how their demeanor changes based on your responses and interactions.",
          iconName: "simulates-real-client-interaction",
        },
        {
          title: "Develop Specialized Skill Sets & Confidence",
          text: "Master the skills you need to effectively care for older adults living with Alzheimer's Disease and similar cognitive impairments.",
          iconName: "develop-specialized-skill-sets",
        },
        {
          title: "Engaging Learning Environments",
          text: "Combining traditional classroom methodologies with real-life field experiences, create unforgettable training experiences.",
          iconName: "engaging-learning-environments",
        },
      ],
      subFields: [
        {
          name: "title",
          type: "string",
          friendlyName: "Benefit Title",
          helperText: "Short, descriptive title for this VR training benefit",
          required: true,
        },
        {
          name: "text",
          type: "longText",
          friendlyName: "Benefit Description",
          helperText:
            "Detailed description explaining how this VR benefit enhances learning",
          required: true,
        },
        {
          name: "iconName",
          type: "string",
          friendlyName: "Icon Selection",
          helperText:
            "Choose the visual icon: simulates-real-client-interaction (VR simulation), develop-specialized-skill-sets (Skills/confidence), engaging-learning-environments (Interactive learning)",
          enum: [
            "simulates-real-client-interaction",
            "develop-specialized-skill-sets",
            "engaging-learning-environments",
          ],
          required: true,
        },
      ],
      helperText:
        "Add or remove VR training benefits to showcase the advantages of immersive learning. Each benefit includes a title, description, and icon.",
      min: 1,
      max: 6,
    },
    {
      name: "layout",
      type: "string",
      friendlyName: "Layout Style",
      defaultValue: "grid",
      enum: ["grid", "list"],
      helperText:
        "Choose layout: grid (3-column cards) or list (vertical stacked)",
      advanced: true,
    },
    {
      name: "backgroundColor",
      type: "string",
      friendlyName: "Background Color",
      defaultValue: "white",
      enum: ["white", "primary-100", "secondary-100"],
      helperText:
        "Background color for the section: white, primary-100 (Light Primary), or secondary-100 (Light Secondary)",
      advanced: true,
    },
    {
      name: "textColor",
      type: "string",
      friendlyName: "Title Text Color",
      defaultValue: "primary-600",
      enum: ["primary-600", "neutral-600", "secondary-600"],
      helperText:
        "Color scheme for the main title: primary-600 (Teal), neutral-600 (Dark Gray), or secondary-600 (Orange)",
      advanced: true,
    },
  ],
};
